/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        ChangePassword,
    } from '../models/index';

            export interface ChangePasswordCreateRequest {
                change_password: ChangePassword;
            }

        /**
        * 
        */
            export class ChangePasswordApi extends runtime.BaseAPI {

            /**
            */
            async changePasswordCreateRaw(requestParameters: ChangePasswordCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangePassword>> {
                    if (requestParameters.change_password === null || requestParameters.change_password === undefined) {
                    throw new runtime.RequiredError('change_password','Required parameter requestParameters.change_password was null or undefined when calling changePasswordCreate.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ChangePassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.change_password,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async post(requestParameters: ChangePasswordCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangePassword> {
                    const response = await this.changePasswordCreateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
